<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">考勤管理&gt;{{attendanceClazzName}}</div>
      </div>
      <div class="body_content">
        <!--考勤详情模态框-->
        <div class="modal fade" id="myModal_attendance" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_attendance" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content details_content" style="width: 800px">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_attendance">
                  {{new_schedule.name}}
                </h4>
              </div>
              <div class="modal-body">
                <div class="body_top">
                  <span>上课日期：{{new_schedule.startDate}}</span>
                  <span>上课时间：{{new_schedule.time}}</span>
                  <!--<span>教学内容：{{new_schedule.name}}</span>-->
                  <span>主讲老师：{{new_schedule.teacherName}}</span>
                </div>
                <div>
                  <input class="form-control" placeholder="请输入学员姓名" style="float: left;width: 180px;margin-bottom: 2%" v-model="searchStudentName"/>
                  <button type="button" class="btn btn-default btn_option" style="float: left;" @click="initAttendanceDetailsList(new_schedule.id,new_schedule.startDate,new_schedule.time,new_schedule.name,new_schedule.teacherName)">查询</button>
                </div>
                <table class="table table-bordered table-striped details_table">
                  <thead>
                  <tr>
                    <th width="15%">学员姓名</th>
                    <!--<th width="25%">工作单位</th>-->
                    <th width="20%">签到时间</th>
                    <th width="10%">签到结果</th>
                    <th width="20%">签退时间</th>
                    <th width="10%">签退结果</th>
                    <th width="10%">操作</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(attendanceDetailOne, index) in attendanceDetailsList" :key="index">
                    <td width="15%">{{attendanceDetailOne.studentName}}</td>
                    <!--<td width="25%">{{attendanceDetailOne.department}}</td>-->
                    <td width="20%"><!--签到时间-->
                      <span v-if="attendanceDetailOne.result1 != '3' && attendanceDetailOne.checkTime2">{{attendanceDetailOne.checkTime1}}</span>
                      <span v-else-if="(attendanceDetailOne.checkTime1 != '' && attendanceDetailOne.checkTime2 == '')"></span>
                      <span v-else></span>
                    </td>
                    <!--0: 正常, 1: 迟到, 2: 早退, 3: 请假, 4: 旷课-->
                    <td width="10%"><!--签到结果-->
                      <span v-if="attendanceDetailOne.result1 && attendanceDetailOne.result2">{{attendanceDetailOne.result1 |formatAttendanceStatus}}</span>
                      <span v-else-if="attendanceDetailOne.result1 =='3'">请假</span>
                      <!--<span v-else-if="attendanceDetailOne.checkTime1 !='' && attendanceDetailOne.checkTime2 ==''">旷课</span>-->
                      <span v-else>旷课</span>
                    </td>
                    <td width="20%"><!--签退时间-->
                      <span v-if="attendanceDetailOne.result1 != '3'">{{attendanceDetailOne.checkTime2}}</span>
                      <span v-else></span>
                    </td>
                    <td width="10%">{{attendanceDetailOne.result2 |formatAttendanceStatus}}</td><!--签退结果-->
                    <td width="10%">
                      <button type="button" class="btn btn-default btn_option" @click="showUpateModal(attendanceDetailOne.studentId,attendanceDetailOne.studentName)">修改考勤</button>
                    </td>
                  </tr>
                  <!-- <tr>
                     <td width="15%"></td>
                     &lt;!&ndash;<td width="25%"></td>&ndash;&gt;
                     <td width="20%">&lt;!&ndash;签到时间&ndash;&gt;

                     </td>
                     &lt;!&ndash;0: 正常, 1: 迟到, 2: 早退, 3: 请假, 4: 旷课&ndash;&gt;
                     <td width="10%">&lt;!&ndash;签到结果&ndash;&gt;

                     </td>
                     <td width="20%">&lt;!&ndash;签退时间&ndash;&gt;

                     </td>
                     <td width="10%"></td>&lt;!&ndash;签退结果&ndash;&gt;
                     <td width="10%">
                       <button type="button" class="btn btn-default btn_option" @click="showUpateModal()">修改考勤</button>
                     </td>
                   </tr>-->
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!--修改考勤模态框-->
        <div class="modal fade" id="myModal_update" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_update" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content" style="width: 800px">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_update">
                  学员：{{getStuName}}
                </h4>
              </div>
              <div class="modal-body">
                <div style="margin: 10px 0">
                  <label>签到状态：</label>
                  <select name="status" class="form-control modelInput" v-model="signInStates"><!--v-model="student.sex"-->
                    <!--<option value="">选择性别</option>-->
                    <option v-for="(val, key, index) in signIntAttendance_status" :value="key">{{val}}</option>
                  </select>
                  <div>
                    <input v-if="signInStates==0 || signInStates==2" type="text" class="form-control modelInput"  name="startDate"  placeholder="输入签到时间" id="chooseStartDate" v-model="startDate" readonly>

                  </div>
                  <!--  <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('student.sex') }}</span>-->
                </div>
                <div>
                  <label>签退状态：</label>
                  <select name="status" class="form-control modelInput" v-model="signOutStates"><!--v-model="student.sex"-->
                    <!--<option value="">选择性别</option>-->
                    <option v-for="(val, key, index) in signOutAttendance_status" :value="key">{{val}}</option>
                  </select>
                </div>
                <div>

                  <input v-if="signInStates==0 || signInStates==2" type="text" class="form-control modelInput"  name="endDate" placeholder="输入签退时间" id="chooseEndDate" v-model="endDate" readonly>

                </div>

              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default" @click="updateStates()">确定</button>
                <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
              </div>
            </div>
          </div>
        </div>

        <div class="classList_div">
          <div style="margin-top: 2%">
            <input class="form-control" placeholder="请输入主讲教师或教学内容" style="float: left;width: 200px;margin-bottom: 1%" v-model="searchName"/>
            <button type="button" class="btn btn-default btn_option" style="float: left;" @click="searchLessonList()">查询</button>
          </div>
          <!--<div id="lesson-page-break">-->
          <table class="table table-striped table-bordered lesson_table">
            <tbody>
            <tr>
              <th width="6%">序号</th>
              <th>教学内容</th>
              <th width="12%">上课日期</th>
              <th width="12%">上课时间</th>
              <th width="20%">主讲教师</th>
              <!--<th width="10%">上课地点</th>-->
              <th width="20%">操作</th>
            </tr>
            <tr v-for="(less, index_less) in lessonList" :key="index_less">
              <td>{{index_less+1}}</td>
              <td>{{less.name}}</td>
              <td>{{less.startDate}}</td>
              <td>{{less.time}}</td>
              <td>{{less.teacherName}}</td>
              <!--<td>{{less.roomName}}</td>-->
              <td>
                <div>
                  <button type="button" class="btn btn-default btn_option" data-dismiss="modal" data-toggle="modal" data-target="#myModal_attendance" @click="initAttendanceDetailsList(less.id,less.startDate,less.time,less.name,less.teacherName)">查看考勤记录</button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <!--分页-->
          <page-view v-bind="searchLessonParams"></page-view>
          <!--</div>-->
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from '../../main';
  import {getContentSize} from '../mainView';
  import pageView from '../pageView';
  import dictionaryData from '../../json/dictionary';

  export default {
    name: "attendanceSchedule",
    components:{pageView},
    data() {
      return {
        attendanceClazzId:this.$store.state.attendanceClazzId,
        attendanceClazzName:this.$store.state.attendanceClazzName,
        clazzName: '',
        signIntAttendance_status: dictionaryData.signIntAttendance_status,
        signOutAttendance_status: dictionaryData.signOutAttendance_status,
        publishStatus : 0,
        classStatus : 0,
        //操作标识
        optionFlag: '',
        creatorId: '',
        //班级发布状态标识
        check_status: dictionaryData.check_status,
        //班级状态标识
        clazz_status: dictionaryData.clazz_status,
        //班级数据列表
        classList: [],

        clazzInfo:{
          startDate:'',
          endDate:'',
        },

        classInfoEditFlag:true,

        numFlag: {
          allNum: 0,
          // havePublish:0,
          noPublish: 0,
          noOpenClass: 0,
          openingClass: 0,
          endClass: 0
        },
        havePublish:0,
        //教务领导
        leaderUserCode: this.$store.state.leaderUserCode,
        userCode: this.$store.state.userCode,

        token: this.$store.state.access_token,
        hrefExport:this.$store.state.serviceBase+"resources/",


        //今日日期
        timeDate: '',

        searchParams: {
          cur: 1,
          all: 0,
          rows: 10
        },

        statusInfo:{
          type1: 0,//全部
          type2: 0,//已发布
          type3: 0,//未发布
          type4: 0,//未开班
          type5: 0,//开班中
          type6: 0//已结业
        },

        searchName:'',

        searchStudentName:'',

        new_schedule:{
          id:'',
          startDate:'',
          time:'',
          name:'',
          teacherName:''
        },
        //考勤集合
        attendanceDetailsList:[],
        //签到状态
        signInStates:'',
        //签退状态
        signOutStates:'',
        startDate:'',
        endDate:'',
        lessonStartTime:'',
        lessonEndTime:'',
        getLessonId:'',
        getStudentId:'',
        getStuName:'',

        //日程分页
        searchLessonParams: {
          cur: 1,
          all: 0,
          rows: 10
        },
        //日程集合
        lessonList:[]

      }
    },
    filters: {
      turnPublishStatusWord(value){
        let this_ = this;
        if(dictionaryData.check_status && value){
          value = dictionaryData.check_status[value];
        }
        return value;
      },
      turnClassStatusWord(value){
        let this_ = this;
        if(dictionaryData.clazz_status && value){
          value = dictionaryData.clazz_status[value];
        }
        return value;
      },
      formatAttendanceStatus(value){
        let this_ = this;
        if(dictionaryData.attendance_status && value){
          value = dictionaryData.attendance_status[value];
        }
        return value;
      }
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        this_.searchParams.page = 1;
        this_.dateDefault();
        // this_.getClassCountsByStatus();

        this_.initLessonList();
        this_.searchLessonParams.page = 1;
        this_.searchLessonParams.pageCallback = this_.initLessonList;
        this_.closeModal();

      });
    },
    watch: {

    },

    methods: {
      /**
       * 加载班级日程
       */
      initLessonList(pageParams){
        let this_ = this;
        this_.searchLessonParams = Object.assign(this_.searchLessonParams, pageParams);
        schoolAxios({
          method: 'get',
          url: 'lesson/findPageByClazzId',
          params: {
            clazzId:this_.attendanceClazzId,
            name:this_.searchName,
            page:this_.searchLessonParams.page,
            rows:this_.searchLessonParams.rows,
          }
        }).then(function (response) {
          let data = response.data;
          if (data.success) {
            this_.lessonList = data.list;
            this_.searchLessonParams.all = data.totalPage;
            /* for(let i = 0;i<this_.trainingScheduleList.length;i++){
               for(let j = 0;j<this_.trainingScheduleList[i].lessons.length;j++){
                 if(!this_.trainingScheduleList[i].lessons[j].teacherId && this_.trainingScheduleList[i].lessons[j].teacherName){
                   if(this_.new_schedule.teacherName == ""){
                     this_.new_schedule.teacherName = this_.searchTeacherName;
                     this_.trainingScheduleList[i].lessons[j].teacherName = this_.trainingScheduleList[i].lessons[j].teacherName + '(外聘)';
                   }
                 }
               }
             }*/
            for(let i = 0;i<this_.lessonList.length;i++){
              if(!this_.lessonList[i].teacherId && this_.lessonList[i].teacherName){
                this_.lessonList[i].teacherName = this_.lessonList[i].teacherName + '(外聘)';
              }
            }
          }
        });
      },

      /**
       * 搜索日程
       */
      searchLessonList(){
        this.searchLessonParams.page = 1;
        this.initLessonList();
      },


      /*考勤详情*/
      initAttendanceDetailsList(lessonId,startDate,time,name,teacherName){
        let this_=this;
        this_.getLessonId = lessonId;
        schoolAxios({
          method: 'get',
          url: 'attendance/getAttendanceListBy',
          params: {
            "lessonId": this_.getLessonId,
            "clazzId":this_.attendanceClazzId,
            "studentName":this_.searchStudentName
          }
        }).then(function (response) {
          // console.info(response);
          let data = response.data;
          if (data.success) {
            this_.new_schedule.id = lessonId;
            this_.new_schedule.startDate = startDate;
            this_.new_schedule.time = time;
            this_.new_schedule.name = name;
            this_.new_schedule.teacherName = teacherName;
            this_.attendanceDetailsList = data.list;
            let _time = time.split("-");
            this_.lessonStartTime = startDate + " " + _time[0];
            this_.lessonEndtTime = startDate + " " + _time[1];
          }
        });
      },
      /**
       * 修改考勤模态框
       */
      showUpateModal(studentId,stuName){
        let this_=this;
        this_.getStudentId = studentId;
        this_.getStuName = stuName;
        schoolAxios({
          method: 'get',
          url: 'attendance/getByLessonIdAndStudentId',
          params: {
            "lessonId": this_.getLessonId,
            "studentId":studentId
          }
        }).then(function (response) {
          // console.info(response);
          let data = response.data;
          if (data.success) {
            let d = data.data;
            this_.signInStates = d.result1;
            this_.signOutStates = d.result2;
            console.log(d.checkTime1, d.checkTime2)
            let s = Math.round(60*Math.random());
            if(s<10) s = '0'+s;
            this_.startDate = d.checkTime1 || (this_.lessonStartTime  + ":" + s);
            s = Math.round(60*Math.random());
            if(s<10) s = '0'+s;
            this_.endDate = d.checkTime2 || (this_.lessonEndtTime + ":" + s);
          }
        });
        $("#myModal_update").modal("show");
      },

      /**
       * 修改考勤
       */
      updateStates(){
        let this_ = this;
        let sd = this_.startDate, ed = this_.endDate;
        if(this_.signInStates == '3' || this_.signInStates == '4'){
          this_.signOutStates = '';
          sd = '';
          ed = '';
        }
        schoolAxios({
          method: "put",
          url: "attendance/updateAttendance",
          data: {
            "lessonId":this_.getLessonId,
            "studentId":this_.getStudentId,
            "result":this_.signInStates,
            "result1":this_.signOutStates,
            "checkTime1":sd,
            "checkTime2":ed,
          },
        }).then(function (resp) {
          let data = resp.data;
          if (data.success) {
            $("#myModal_update").modal("hide");
            this_.initAttendanceDetailsList(this_.new_schedule.id,this_.new_schedule.startDate,this_.new_schedule.time,this_.new_schedule.name,this_.new_schedule.teacherName);
            // this_.initLessonList()
          } else {
            data.message.showMessage();
          }
        })
      },
      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#myModal_attendance").on('hide.bs.modal', function () {
          this_.searchStudentName = ''
        });
      },

      /**
       * 初始化日期选择框
       */
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('#chooseStartDate').datetimepicker({
          language: 'zh-CN',
          dateFormat: 'yyyy-mm-dd',
          timeFormat: 'HH:mm:ss',
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          minView:0,
          startView: 2,
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#chooseStartDate").val();
          this_.startDate = value;
          ev.preventDefault();
          ev.stopPropagation();
        });
        $('#chooseEndDate').datetimepicker({
          language: 'zh-CN',
          dateFormat: 'yyyy-mm-dd',
          timeFormat: 'HH:mm:ss',
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          minView:0,
          startView: 2,
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#chooseEndDate").val();
          this_.endDate = value;
          ev.preventDefault();
          ev.stopPropagation();
        });
      },
    },
    /*computed: {
      indexs(){
        var left = 1;
        var right = this.searchParams.all;
        var arr = [];
        if(this.searchParams.all>=7){
          if(this.searchParams.page>4 && this.searchParams.page<this.searchParams.all-3){
            left = this.searchParams.page-3;
            right = this.searchParams.page+3;
          }else if(this.searchParams.page<=4){
            left=1;
            right=7;
          }else{
            left=this.searchParams.all-6;
            right=this.searchParams.all;
          }
        }
        while(left<=right){
          arr.push(left);
          left++;
        }
        return arr;
      }
    }*/
  }
</script>

<style scoped>
  @import '../../assets/css/plugins.css';
  @import "../../assets/css/publicStyle.css";
  .situation_all_div {
    position: relative;
    top: 2%;
    width: 100%;
    height: 10%;
  }
  .situation_one_div {
    float: left;
    width: 14%;
    height: 100%;
    color: white;
    font-size: 18px;
    line-height: 75px;
    margin: 0px 1% 1% 1%;
    padding-left: 20px;
  }
  .situation_one_div:nth-child(1) {
    background-color: #ff4d42;
  }
  /*已发布*/
  .situation_one_div:nth-child(2) {
    background-color: #FF5A58;
  }
  .situation_one_div:nth-child(3) {
    background-color: #fb6b51;
  }
  .situation_one_div:nth-child(4) {
    background-color: #f78a42;
  }
  .situation_one_div:nth-child(5) {
    background-color: #f79851;
  }
  .situation_one_div:nth-child(6) {
    background-color: #eba600;
  }
  .situation_one_div span {
    font-size: 45px;
    font-weight: bold;
  }
  .situation_one_div div {
    float: right;
    width: 25%;
    height: 100%;
  }
  .situation_one_img {
    background-color: #d6483f;
    text-align: center;
  }
  .situation_two_img {
    background-color: #d5604b;
    text-align: center;
  }
  .situation_three_img {
    background-color: #d0793f;
    text-align: center;
  }
  .situation_four_img {
    background-color: #d0844b;
    text-align: center;
  }
  .situation_five_img {
    background-color: #c68f0a;
    text-align: center;
  }
  .situation_six_img {
    background-color: #D6594E;
    text-align: center;
  }

  /*.situation_one_div div img {
    margin-left: 18%;
  }*/


  .classList_div {
    position: relative;
    /*top: 2%;*/
    width: 100%;
    height: 86%;
    overflow: auto;
  }

  table tr{
    text-align: center;
  }
  table th {
    background: #cccccc;
    text-align: center;
  }
  .table-striped {
    /*background-color: #D7D7D7;*/
  }
  /*.table tbody{
    display: block;
    height: 640px;
    overflow: auto;
  }*/
  .modelInput {
    /*width: 70%;*/
  }


  .action_pic {
    margin-left: 20%;
  }
  .edit_pic {
    width: 29px;
    height: 22px;
    /*background-image: url("../img/right/clazz/edit_disabled.png");*/
    background-size: 100% 100%;
    float: left;
  }
  .delete_pic {
    width: 29px;
    height: 22px;
    /*background-image: url("../img/right/clazz/delete_disabled.png");*/
    background-size: 100% 100%;
    float: left;
  }
  .details_pic {
    width: 29px;
    height: 22px;
    /*background-image: url("../img/right/clazz/details_disabled.png");*/
    background-image: url("../../assets/img/right/clazz/details.png");
    background-size: 100% 100%;
    float: left;
  }
  .show_edit_pic {
    /*background-image: url("../img/right/clazz/edit_mouseOver.png");*/
    cursor: pointer;
  }
  .show_delete_pic {
    /*background-image: url("../img/right/clazz/delete_mouseOver.png");*/
    cursor: pointer;
  }
  .show_details_pic {
    /*background-image: url("../img/right/clazz/details_mouseOver.png");*/
    cursor: pointer;
  }


  .edit_pic,.delete_pic,.details_pic {
    margin: 0 0 0 12%;
  }
  .export_content {
    position: relative;
    left: 30%;
    width: 400px;
  }
  .export_header,.export_class{
    text-align: center;
  }
  .body_top {
    margin-bottom: 10px;
  }
  .body_top span {
    margin-right: 20px;
  }



  /*  .details_table tbody{
      height: 300px;
    }*/
  .details_content {
    width: 900px;
    /*height: auto;*/
    height: 900px;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/attendanceManagement/attendanceSchedule.vue